import { SendDataBase } from './sendDataBase.data';

export interface SendSMSData extends SendDataBase<SMSLabsStatus> {
  statusDescription?: string;
  message: string;
  phoneNumber: string;
  receiverIds: string[];
  type: SMSType;
  errors: string[];
  /** No of sent packets (SMS per message)*/
  sentPackets?: number;
}

export enum SMSLabsStatus {
  NEW = 1,
  SENT = 2,
  NOT_DELIVERED = 9,
  DELIVERED = 21
}

export enum SMSType {
  APP_INVITE = 'app_invite',
  APP_INVITE_ACA = 'app_invite_aca',
  /** @deprecated remove after service app force update */
  SERVICE_INVITE_LEGACY = 'service_invite',
  SERVICE_INVITE = 'service_invite_otp',
  ALERT = 'alert'
}
